<!-- TermsModal.vue -->
<template>
  <div v-if="show" class="fixed inset-0 z-50 overflow-y-auto">
    <div
      class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <!-- Pozadinski overlay -->
      <div
        class="fixed inset-0 transition-opacity"
        aria-hidden="true"
        @click="close"
      >
        <div class="absolute inset-0 bg-gray-900 opacity-80"></div>
      </div>

      <!-- Centriranje modala -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <!-- Modal -->
      <div
        class="inline-block align-bottom bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <!-- Zaglavlje modala -->
        <div
          class="bg-indigo-600 px-4 py-3 sm:px-6 flex justify-between items-center"
        >
          <h3
            class="text-lg leading-6 font-medium text-white"
            id="modal-headline"
          >
            Uslovi korišćenja
          </h3>
          <button
            @click="close"
            type="button"
            class="text-white hover:text-gray-200 focus:outline-none"
          >
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <!-- Sadržaj modala -->
        <div
          class="bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4 max-h-[70vh] overflow-y-auto text-gray-300"
        >
          <div class="space-y-4">
            <h2 class="text-xl font-bold mb-4 text-indigo-400">
              PRAVILA KORIŠĆENJA - Moja Garderoba
            </h2>

            <div class="mb-6">
              <p class="text-sm text-gray-300 mb-4">
                Dobrodošli na sajt Moja Garderoba, platformu za kupovinu i prodaju
                polovne odeće među korisnicima. Korišćenjem našeg sajta
                (www.mojagarderoba.rs) prihvatate sledeća pravila korišćenja.
                Molimo vas da ih pažljivo pročitate.
              </p>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                1. Opšti uslovi
              </h3>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-2">
                <li>
                  Ovi uslovi regulišu korišćenje sajta Moja Garderoba, u vlasništvu
                  kompanije Devfinity Solutions.
                </li>
                <li>
                  Korišćenjem sajta potvrđujete da ste pročitali, razumeli i
                  prihvatili ova pravila.
                </li>
                <li>
                  Ako se ne slažete sa bilo kojim delom ovih pravila, nemojte
                  koristiti sajt.
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                2. Registracija i korisnički nalog
              </h3>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-2">
                <li>
                  Da biste objavljivali oglase ili kupovali artikle, potrebno je
                  da kreirate korisnički nalog.
                </li>
                <li>
                  Prilikom registracije ste dužni da unesete tačne i potpune
                  informacije.
                </li>
                <li>
                  Korisnik je odgovoran za čuvanje poverljivosti lozinke i
                  aktivnosti koje se dešavaju putem njegovog naloga.
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                3. Oglasi i sadržaj korisnika
              </h3>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-2">
                <li>
                  Korisnici mogu postavljati oglase za prodaju svoje polovne
                  odeće.
                </li>
                <li>
                  Zabranjeno je postavljanje sadržaja koji je uvredljiv,
                  nezakonit, obmanjujući, krši autorska prava ili prava trećih
                  lica.
                </li>
                <li>
                  Moja Garderoba zadržava pravo da ukloni svaki sadržaj koji krši
                  ova pravila.
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                4. Kupoprodaja između korisnika
              </h3>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-2">
                <li>
                  Moja Garderoba je samo posrednička platforma – ne garantujemo
                  ispravnost artikala, niti odgovaramo za neuspele transakcije.
                </li>
                <li>
                  Korisnici su sami odgovorni za dogovor o isporuci, načinu
                  plaćanja i rešavanju eventualnih nesporazuma.
                </li>
                <li>
                  Preporučujemo upotrebu bezbednih metoda plaćanja i ličnu
                  provere artikla pre kupovine.
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">5. Zabrane</h3>
              <p class="text-sm text-gray-300 mt-1">
                Korisnicima je zabranjeno:
              </p>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-1">
                <li>Lažno predstavljanje</li>
                <li>Prodaja ukradene ili zabranjene robe</li>
                <li>Uznemiravanje drugih korisnika</li>
                <li>
                  Automatizovano korišćenje sajta bez dozvole (npr. botovi)
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                6. Ograničenje odgovornosti
              </h3>
              <p class="text-sm text-gray-300 mt-1">
                Moja Garderoba ne odgovara za:
              </p>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-1">
                <li>Tačnost i verodostojnost oglasa</li>
                <li>Štetu nastalu korišćenjem sajta</li>
                <li>Neuspele transakcije i gubitak podataka</li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                7. Zaštita privatnosti
              </h3>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-2">
                <li>
                  Vaši podaci se obrađuju u skladu sa našom Politikom
                  privatnosti.
                </li>
                <li>
                  Ne delimo vaše lične informacije trećim stranama bez vašeg
                  pristanka, osim u slučajevima kada to zahteva zakon.
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">
                8. Izmene pravila
              </h3>
              <ul class="list-disc ml-5 text-sm text-gray-300 space-y-1 mt-2">
                <li>
                  Zadržavamo pravo da u bilo kom trenutku izmenimo ova pravila.
                </li>
                <li>
                  O izmenama ćete biti obavešteni putem sajta ili e-pošte.
                </li>
                <li>
                  Dalje korišćenje sajta nakon izmena znači da prihvatate nove
                  uslove.
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <h3 class="text-lg font-semibold text-indigo-400">9. Kontakt</h3>
              <p class="text-sm text-gray-300 mt-2">
                Za sva pitanja i prijave zloupotreba možete nas kontaktirati na:
              </p>
              <p class="text-sm text-indigo-400 mt-1">
                📧 devfinity.solutions.contact@gmail.com
              </p>
            </div>
          </div>
        </div>

        <!-- Footer modala -->
        <div class="bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 focus:ring-offset-gray-700 sm:ml-3 sm:w-auto sm:text-sm"
            @click="acceptTerms"
          >
            Prihvatam
          </button>
          <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-600 shadow-sm px-4 py-2 bg-gray-800 text-base font-medium text-gray-300 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 focus:ring-offset-gray-700 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            @click="close"
          >
            Zatvori
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TermsModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'accept'],
  methods: {
    close() {
      this.$emit('close');
    },
    acceptTerms() {
      this.$emit('accept');
      this.close();
    },
  },
});
</script>
